import { TaskQueue } from "../shared/queue";

export default (_ctx: any, inject: Function) => {
  inject("queue", new TaskQueue());
};
